<header class="header-style4" id="header-section9">
    <!-- nav -->
    <nav class="navbar bg-white white-header alt-font no-margin no-padding shrink-medium-header light-header">
        <div class="header-bottom bg-white">
            <div class="container navigation-menu">
                <div class="row">
                    <!-- logo -->
                    <div class="col-md-3 col-sm-4 col-xs-9">
                        <a routerLink="/inicio" routerLinkActive="active" class="inner-link"><img alt=""
                                src="assets/images/logo.png" data-img-size="(W)163px X (H)39px"></a>
                    </div>
                    <!-- end logo -->
                    <div class="col-md-9 col-sm-8 col-xs-3 position-inherit">
                        <button data-target="#bs-example-navbar-collapse-1" data-toggle="collapse"
                            class="navbar-toggle collapsed" type="button" (click)="isCollapsed = !isCollapsed">
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <div id="bs-example-navbar-collapse-1" class="collapse navbar-collapse pull-right"
                            [collapse]="isCollapsed">
                            <ul class="nav navbar-nav  font-weight-500">
                                <li class="propClone"><a class="" routerLink="/inicio" routerLinkActive="active"
                                        (click)="isCollapsed = true">INICIO</a></li>
                                <li class="propClone"><a class="" routerLink="/empresa" routerLinkActive="active"
                                        (click)="isCollapsed = true">LA EMPRESA </a></li>
                                <li class="propClone dropdown" dropdown>
                                    <a dropdownToggle href="javascript:void(0)" class="dropdown-toggle"
                                        data-toggle="dropdown">GANADO ONLINE </a>
                                    <ul *dropdownMenu class="dropdown-menu">
                                        <li><a routerLink="/subastas" routerLinkActive="active" class="dropdown-item"
                                                (click)="isCollapsed = true">VER LOTES</a></li>
                                        <li><a routerLink="/como-funciona" routerLinkActive="active"
                                                class="dropdown-item" (click)="isCollapsed = true">COMO FUNCIONA </a>
                                        </li>
                                        <li><a class="dropdown-item" routerLink="/condiciones-subasta"
                                                routerLinkActive="active" (click)="isCollapsed = true">CONDICIONES DE
                                                SUBASTA </a></li>
                                        <li><a class="dropdown-item" routerLink="/resumen-precios"
                                                routerLinkActive="active" (click)="isCollapsed = true">RESUMEN DE
                                                PRECIOS</a></li>
                                    </ul>
                                </li>
                                <li class="propClone"><a class=""
                                        routerLink="/propiedades-rurales" routerLinkActive="active"
                                        (click)="isCollapsed = true">PROPIEDADES RURALES </a>
                                </li>
                                <li class="propClone"><a class="" routerLink="/contacto" routerLinkActive="active"
                                        (click)="isCollapsed = true">CONTÁCTENOS</a></li>
                                <li *hasPermission="'ROLE_ADMIN'" class="propClone"><a class=""
                                        href="/dobro-api/web/app_dev.php/backend"
                                        (click)="isCollapsed = true">ADMINISTRACIÓN</a></li>
                                <li *ngIf="!logueado"><a routerLink="/registro" routerLinkActive="active"
                                        (click)="isCollapsed = true"><span class="" id="">REGISTRARSE</span></a></li>
                                <li *ngIf="!logueado"><a routerLink="/login" routerLinkActive="active"><span class=""
                                            id="" (click)="isCollapsed = true">INGRESAR</span></a></li>
                                <li class="propClone dropdown" *ngIf="logueado" dropdown>
                                    <a dropdownToggle href="javascript:void(0)" class="dropdown-toggle"
                                        data-toggle="dropdown">MI CUENTA</a>
                                    <ul *dropdownMenu class="dropdown-menu">
                                        <li>
                                            <a class="dropdown-item" routerLink="/mi-cuenta" routerLinkActive="active"
                                                (click)="isCollapsed = true"><span class="" id="">
                                                    <div class="fa fa-user"></div> {{nombreUsuario}}
                                                </span></a>
                                        </li>
                                        <li><a class="dropdown-item" (click)="logout()"
                                                (click)="isCollapsed = true"><span class="" id="">SALIR</span></a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <!-- end nav -->
</header>
<router-outlet></router-outlet>
<section class="bg-white  padding-30px-tb xs-padding-60px-tb border-none" id="">
    <div class="container">
        <div class="row">
            <owl-carousel [options]="{itemsDesktop: [600, 5], 
                    responsiveClass: true, 
                    itemsTablet: [600, 2], 
                    itemsMobile: [600, 1], 
                    dots: true,
                    slideSpeed: 300, 
                    autoPlay: 5000, 
                    paginationSpeed: 400, 
                    navigation: false}" [items]="imagenesAuspicio2"
                [carouselClasses]="['owl-carousel', 'owl-theme', 'owl-slider-auto', 'owl-no-buttons', 'carousel-auspicio']">
                <div *ngFor="let image of imagenesAuspicio2; let i=index">
                    <img class="auspicio" [src]="image.thumb" (click)="openImage(i)">
                </div>
            </owl-carousel>
        </div>
    </div>
</section>
<footer class="bg-dark-gray footer-style8 border-top padding-30px-tb xs-padding-40px-tb" id="">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12 sm-text-center sm-margin-five-bottom ">
                <!-- logo -->
                <a class="margin-eight-bottom display-inline-block inner-link" routerLink="/inicio"
                    routerLinkActive="active"><img src="assets/images/logo-white.png" data-img-size="(W)163px X (H)39px"
                        alt=""></a>
                <!-- end logo -->
                <div class="text-light-gray width-80 sm-width-100">
                    <p class="no-margin-bottom"> Bomberos Voluntarios 553 entre Azara y Cerro Cora<br> Asunción - Paraguay<br>Teléfonos:
                        0981583539 / 0981437195<br>E-mail: info@tropeando.com.py<br><br></p>
                </div>
            </div>
            <!-- links -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-nine-bottom xs-text-center">
                <ul class="links">
                    <li class="text-medium margin-seven-bottom font-weight-600 text-white xs-margin-one-half-bottom">
                        Secciones</li>
                    <li><a class="text-light-gray" routerLink="/inicio" routerLinkActive="active">Inicio</a></li>
                    <li><a class="text-light-gray" routerLink="/empresa" routerLinkActive="active">La Empresa</a></li>
                    <li *ngIf="!logueado"><a class="text-light-gray" routerLink="/login"
                            routerLinkActive="active">Ingresar</a></li>
                    <li *ngIf="!logueado"><a class="text-light-gray" routerLink="/registro"
                            routerLinkActive="active">Registrarse</a></li>
                    <li *ngIf="logueado"><a class="text-light-gray" routerLink="/mi-cuenta" routerLinkActive="active">Mi
                            cuenta </a>
                    </li>
                    <li><a class="text-light-gray" routerLink="/contacto" routerLinkActive="active">Contáctenos</a></li>
                </ul>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-nine-bottom xs-text-center">
                <ul class="links">
                    <li class="text-medium margin-seven-bottom font-weight-600 text-white xs-margin-one-half-bottom">
                        Ganado Online </li>
                    <li><a class="text-light-gray inner-link" routerLink="/subastas" routerLinkActive="active">Subastas
                        </a></li>
                    <li><a class="text-light-gray inner-link" routerLink="/como-funciona" routerLinkActive="active">Cómo
                            funciona </a></li>
                    <li><a class="text-light-gray inner-link" routerLink="/condiciones-subasta"
                            routerLinkActive="active">Condiciones de subasta</a></li>
                    <li><a class="text-light-gray inner-link" routerLink="/resumen-precios"
                            routerLinkActive="active">Resúmen de precios</a></li>
                </ul>
            </div>
            <!-- end links -->
        </div>
        <div class="row equalize">
            <div class="border-top-light no-margin">
                <div class="col-md-6 col-sm-6 col-xs-12 display-table xs-text-center xs-margin-nine-bottom">
                    <div class="display-table-cell-vertical-middle">
                        <span class=" text-small">Todos los derechos © {{copyright}} Tropeando - Ganado Online.</span>
                        v{{versionString}} Desarrollado por Roshka</div>
                </div>
            </div>
        </div>
    </div>
    <!-- Botón flotante de WhatsApp -->
    <a class="botonWhat"
        [href]="whatsappLink" target="_blank" rel="noopener" aria-label="WhatsApp">
        <div class="btn-whatsapp">
            <i class="fab fa-whatsapp"></i>
        </div>
    </a>
</footer>
